import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { APP_NAME, APP_VERSION } from '../../../core/version/app-version';
import { BUILD_NUMBER } from '../../../core/version/build-info';

@Component({
  selector: 'vex-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule]
})
export class FooterComponent implements OnInit, OnDestroy {
  appName = APP_NAME;
  appVersion = APP_VERSION;
  buildNumber = BUILD_NUMBER;

  constructor() {}

  ngOnInit() {}

  ngOnDestroy(): void {}
}
